import { format, isValid } from "date-fns";

export const formatDate = ({ day, month, year }) =>
  format(new Date(`${year}-${month}-${day}`), "yyyy-MM-dd");

export const formatDate2 = ({ day, month, year }) => {
  const theDate = new Date(`${year}-${month}-${day}`);
  return isValid(theDate) ? format(theDate, "dd/MM/yyyy") : "";
};
